export default {
  padding: '8px 14px'
}
